module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.$can(_vm.domain + '.update')) ? _c('router-link', {
    staticClass: "el-button el-button--info",
    attrs: {
      "to": {
        name: _vm.routeName,
        params: {
          id: _vm.item.id
        }
      },
      "title": "Editar Dados"
    }
  }, [_c('i', {
    staticClass: "el-icon-edit"
  })]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-3022ddd2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/components/list/EditButton.vue
// module id = 737
// module chunks = 2